// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { propertiesModel } from '@/firebase/firebase-config'

export const GetActiveLease = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        active_lease: null

    }),

    /*
	**  Methods
    */
    
    methods: {

        getActiveLeaseHandler: function(property_id, resident_id) {

            try {

                /*
                **  Reset the prop
                **  @prop: @here
                */

                this.active_lease = null;

                /*
                **  Get the lease document
                **  @service: @Firebase/Firestore
                */

                propertiesModel.doc(property_id).collection('leases').where('relationships.resident', '==', resident_id).where('attributes.status', '==', 'active').limit(1).get()
                .then(snapshot => {

                    if (snapshot.empty) return;

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    snapshot.forEach(doc => {

                        this.active_lease = doc.data();

                    });

                })
                .catch(error => {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Get the Active Lease from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Leases',
                        uid: 'RtZZkLSf18g9Mx4ahCkH',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Perform the Query to Get the Active Lease Document from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Leases',
                    uid: 'BHAyW3LfYF3oxfwYwyNp',
                    error: e
                });

            }

        }

    }

}